// extracted by mini-css-extract-plugin
module.exports = {"dataProcessingAgreement":"DataProcessingAgreement-module--data-processing-agreement--ryx7u"};